import createSvgIcon from "./utils/create_icon"

const ImageSmall = createSvgIcon(<path clipRule="evenodd" d="M7 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm8.707 5.707L17 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2l1.293-1.293a1 1 0 0 1 1.414 0L13 14l1.293-1.293a1 1 0 0 1 1.414 0zM14 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0z" fill="currentColor" fillRule="evenodd" />, "ImageSmall")
export default ImageSmall
